function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

import React from 'react';
import classnames from 'classnames';
import { IMaskInput } from 'react-imask';
import InputGroup from "./InputGroup";
import InputGroupAddon from "./InputGroupAddon";
var defaultProps = {
  allowDecimal: true,
  allowNegative: false,
  includeThousandsSeparator: true,
  padZeros: true
}; // TODO support I18n

var CurrencyInput = function CurrencyInput(_ref) {
  var _ref$allowDecimal = _ref.allowDecimal,
      allowDecimal = _ref$allowDecimal === void 0 ? defaultProps.allowDecimal : _ref$allowDecimal,
      _ref$allowNegative = _ref.allowNegative,
      allowNegative = _ref$allowNegative === void 0 ? defaultProps.allowNegative : _ref$allowNegative,
      className = _ref.className,
      _ref$includeThousands = _ref.includeThousandsSeparator,
      includeThousandsSeparator = _ref$includeThousands === void 0 ? defaultProps.includeThousandsSeparator : _ref$includeThousands,
      inputProps = _ref.inputProps,
      innerRef = _ref.innerRef,
      _ref$padZeros = _ref.padZeros,
      padZeros = _ref$padZeros === void 0 ? defaultProps.padZeros : _ref$padZeros,
      size = _ref.size,
      value = _ref.value,
      onChange = _ref.onChange,
      props = _objectWithoutProperties(_ref, ["allowDecimal", "allowNegative", "className", "includeThousandsSeparator", "inputProps", "innerRef", "padZeros", "size", "value", "onChange"]);

  var inputClassNames = classnames('form-control', inputProps && inputProps.className);

  var onAccept = function onAccept(val, mask) {
    if (onChange) {
      var ev = new Event('change'); // @ts-ignore

      mask.el.input.dispatchEvent(ev);
      onChange(ev);
    }
  };

  var maskedProps = _objectSpread(_objectSpread(_objectSpread({}, inputProps), props), {}, {
    className: inputClassNames,
    mask: Number,
    onAccept: onAccept,
    padFractionalZeros: allowDecimal && padZeros,
    radix: '.',
    scale: allowDecimal ? 2 : 0,
    signed: allowNegative,
    thousandsSeparator: includeThousandsSeparator ? ',' : ''
  });
  /**
   * This allows persisting value between re-renders when using `CurrencyInput`
   * as uncontrolled component.
   * `react-imask` detects 'value' key in the props and sets the input value accordingly,
   * even if it's passed as `undefined`.
   * https://github.com/uNmAnNeR/imaskjs/blob/master/packages/react-imask/src/mixin.ts#L139-L147
   */


  if (value !== undefined) {
    maskedProps.value = value.toString();
  }

  if (innerRef) {
    maskedProps.inputRef = innerRef;
  }

  return /*#__PURE__*/React.createElement(InputGroup, {
    size: size,
    className: className
  }, /*#__PURE__*/React.createElement(InputGroupAddon, {
    addonType: "prepend"
  }, "$"), /*#__PURE__*/React.createElement(IMaskInput, maskedProps));
};

CurrencyInput.displayName = "CurrencyInput";
CurrencyInput.displayName = 'CurrencyInput';
CurrencyInput.defaultProps = defaultProps;
export default CurrencyInput;